import {useEffect, useRef, useState} from 'react'
import {SActionBtn, SDrawerOrModal, SGeneralForms, SLowcodeList, SMessage, STableActions,} from 'shj-components'
import {config} from './config'
import {
  getProjectPage,
  getSpecialCodesList,
  projectDelete,
  projectSave,
  projectUpdateById,
  projectUpdateState,
} from '@/services/product.ts'
import {apiData2Table, trimStr} from '@/utils/data.ts'
import {message, Select, Switch} from 'antd'
import {isEmpty} from 'lodash-es'

export default function ProjectManage() {
  const listRef = useRef<any>()
  const formRef = useRef<any>()
  const [open, setOpen] = useState<boolean>(false)
  const [record, setRecord] = useState<any>({})
  const [btnLoading, setBtnLoading] = useState<boolean>(false)
  const [specialCodeList, setSpecialCodeList] = useState<any[]>([])
  const fetchList = values => {
    const {current, pageSize, ...rest} = values
    rest.query.orderBys = [
      {
        columnName: 'id',
        asc: false,
      },
    ]
    return new Promise((resolve, reject) => {
      getProjectPage({
        params: {pageId: current, pageSize},
        data: rest.query,
      })
        .then(res => {
          resolve(apiData2Table(res as any))
        })
        .catch(reject)
    })
  }
  const onAdd = () => onEdit()
  const onEdit = (record = {}) => {
    setOpen(true)
    setRecord(record)
  }

  useEffect(() => {
    if (!isEmpty(record)) formRef.current?.onFormRef().setFieldsValue(record)
    return () => {
      formRef.current?.onFormRef().resetFields()
    }
  }, [record])

  //  表格事件: 删除
  const onDel = id => {
    SMessage.confirm({
      onOk: () => {
        return projectDelete(id).then((res: any) => {
          message.success(res.message || '操作成功')
          listRef.current?.reload()
        })
      },
    })
  }

  const onChangeStatus = (enabled: boolean, id: string) => {
    SMessage.confirm({
      title: `${enabled ? '打开' : '关闭'}开关，将${enabled ? '启用' : '禁用'}项目，是否继续？`,
      okText: '继续',
      content: null,
      onOk: () => {
        return projectUpdateState({enabled, idList: [id]}).then((res: any) => {
          message.success(res.message || '操作成功')
          listRef.current?.reload()
        })
      },
    })
  }

  const onSubmit = () => {
    formRef.current
      ?.onFormRef()
      .validateFields()
      .then(values => {
        setBtnLoading(true)
        const apiUrl = values.id ? projectUpdateById : projectSave
        apiUrl({data: {...values}})
          .then((res: any) => {
            message.success(res.message || '操作成功')
            listRef.current?.reload()
            setOpen(false)
          })
          .finally(() => setBtnLoading(false))
      })
  }

  const extensions = {
    request: {fetchList},
    events: {
      onAdd,
    },
    status: {
      selectedDisabled: ({selectedRowKeys}: any) => !selectedRowKeys.length,
      radioDisabled: ({selectedRowKeys}: any) => selectedRowKeys.length !== 1,
    },
    customRender: {
      switchRender(v: boolean, record: Record<string, any>) {
        return <Switch checked={v} checkedChildren="启用" unCheckedChildren="禁用"
                       onClick={checked => onChangeStatus(checked, record.id)}/>
      },
      actionRender(_, record: Record<string, any>) {
        return (
          <STableActions>
            <SActionBtn onClick={() => onEdit(record)}>编辑</SActionBtn>
            <SActionBtn danger onClick={() => onDel(record.id)}>
              {' '}
              删除{' '}
            </SActionBtn>
          </STableActions>
        )
      },
    },
  }
  const getOptions = async (): Promise<{ [key: string]: any }> => {
    let specialCodeList: any = await getSpecialCodesList({
      data: {},
    })
    specialCodeList = specialCodeList.map(item => ({label: item.showName, value: item.code}))
    setSpecialCodeList(specialCodeList)
    return Promise.resolve({specialCodeList})
  }

  return (
    <div>
      <SLowcodeList ref={listRef} searchMode="group" config={config} {...extensions} />
      <SDrawerOrModal
        title={(record.id ? '编辑' : '新增') + '项目'}
        mode="modal"
        open={open}
        loading={btnLoading}
        onCancel={() => setOpen(false)}
        onOk={onSubmit}
        width={500}
      >
        <SGeneralForms
          ref={formRef}
          layout={'vertical'}
          httpOptionsFn={getOptions}
          configs={[
            {
              formItem: [
                {label: 'id', name: 'id', hidden: true},
                {
                  label: '项目名称',
                  name: 'itemName',
                  spanCol: 24,
                  required: true,
                  rules: [{required: true, message: '项目名称不能为空'}],
                  comConfig: {
                    showCount: true,
                    maxLength: 15,
                    onChange: e =>
                      formRef.current
                        ?.onFormRef()
                        ?.setFieldValue('itemName', trimStr(e.target.value)),
                  },
                },
                {
                  name: 'specialCode',
                  label: '特项代码',
                  spanCol: 24,
                  children: (
                    <Select
                      allowClear
                      options={specialCodeList}
                      placeholder="请选择"
                      showSearch
                      filterOption={(input, option) =>
                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                      }
                      onChange={e => formRef.current?.onFormRef()?.setFieldValue('specialCode', e)}
                    />
                  ),
                },
              ],
            },
          ]}
        />
      </SDrawerOrModal>
    </div>
  )
}
